import type { FC } from 'react';
import ReactHighCharts from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import Highcharts, { type Options, type SeriesOptionsType } from 'highcharts/highmaps';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import HighchartsExporting from 'highcharts/modules/exporting';
export const Chart: FC<ChartProps> = ({
  options,
  series,
  xAxis
}) => {
  const chartOptions: Options = {
    ...options,
    series,
    xAxis: {
      ...options.xAxis,
      categories: xAxis
    }
  };
  if (typeof Highcharts === 'object') {
    HighchartsExporting(Highcharts);
    HighchartsMore(Highcharts);
    HighchartsAccessibility(Highcharts);
  }
  return <ReactHighCharts highcharts={Highcharts} constructorType="chart" options={chartOptions} allowChartUpdate={true} updateArgs={[true, true, true]} data-sentry-element="ReactHighCharts" data-sentry-component="Chart" data-sentry-source-file="index.tsx" />;
};
export type ChartProps = {
  options: Options;
  series: SeriesOptionsType[];
  xAxis?: string[];
};